import React from 'react';
import styles from './forbidden-popup.module.scss';
import { useTranslation } from "react-i18next";
import { ReactComponent as ForbiddenIcon } from "@/assets/icons/forbidden.svg";

interface ForbiddenPopup {
    onClose?: () => void;
}
export const ForbiddenPopup: React.FC<ForbiddenPopup> = ({ onClose }) => {
    const { t } = useTranslation();

    return (
        <div className={styles.cardContainer}>
            <div className={styles.logoContainer}><ForbiddenIcon /></div>
            <h2 className={styles.text}>{t('forbidden')}</h2>
            <p className={styles.subText}>
                {t('forbidden_msg')}
            </p>
            {onClose && <button className={styles.button} onClick={onClose}>
                {t('close')}
            </button>}
        </div>
    );
}

